import { fetchTitilerPointValue } from '../utils/titilerPoint';

/**
 * Shared planting method legend used across map legends and UI.
 * Blue = Direct-seeded, Orange = Transplanted.
 */
export const PLANTING_METHOD_COGS = {
  dry2025:
    'https://digisaka.s3.ap-southeast-1.amazonaws.com/Planting%20Method%20Map/dry2025_Philippines_cog.tif',
  dry2024:
    'https://digisaka.s3.ap-southeast-1.amazonaws.com/Planting%20Method%20Map/dry2024_Philippines_cog.tif',
} as const;

export const PLANTING_METHOD_LEGEND: {
  colors: string[];
  labels: string[];
  description: string;
} = {
  colors: ['#00FFFF', '#FF5500'], // Blue for Direct-seeded, Orange for Transplanted
  labels: ['Direct-seeded', 'Transplanted'],
  description: 'Rice planting method classification',
};

export async function fetchPlantingMethodPoint(
  cogUrl: string,
  lon: number,
  lat: number,
  signal?: AbortSignal
): Promise<{ value: number | null; label: string; color: string }> {
  const raw = await fetchTitilerPointValue(cogUrl, lon, lat, { signal });
  const klass = raw == null ? null : Math.round(raw);
  if (klass !== 0 && klass !== 1) {
    return { value: null, label: 'No data', color: '#9ca3af' };
  }
  return {
    value: klass,
    label: PLANTING_METHOD_LEGEND.labels[klass],
    color: PLANTING_METHOD_LEGEND.colors[klass],
  };
}
